export default {
    handleErrors(error) {
        if (typeof error.response !== 'undefined' &&
            typeof error.response.data !== 'undefined' &&
            typeof error.response.data.success !== 'undefined' &&
            error.response.data.success == false) {

            if (error.response.data.error && error.response.data.error === 'validation' && error.response.data.errorData) {

                console.error(error.response.data.errorData);
                return { success: false, error: 'Error de API:<Br />' + error.response.data.errorData };

            }

            console.error(error.response.data.error);
            return error.response.data;

        } else {
            return { success: false, error: error.message };
        }
    }
}